var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var TIMEOUT_MS = 120000;
var sendJsonRequest = function (_a) {
    var _b = _a.method, method = _b === void 0 ? 'GET' : _b, url = _a.url, body = _a.body;
    return __awaiter(void 0, void 0, void 0, function () {
        var abortController, timer, response_1, _c, error;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    abortController = new AbortController();
                    timer = setTimeout(function () { return abortController.abort(); }, TIMEOUT_MS);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, , 8, 9]);
                    return [4 /*yield*/, fetch(url, {
                            body: body ? JSON.stringify(body) : undefined,
                            credentials: 'include',
                            headers: body ? { 'Content-Type': 'application/json' } : {},
                            method: method,
                            signal: abortController.signal
                        })];
                case 2:
                    response_1 = _d.sent();
                    if (!response_1.ok) return [3 /*break*/, 6];
                    if (!(response_1.status === 204)) return [3 /*break*/, 3];
                    _c = undefined;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, response_1.json()];
                case 4:
                    _c = (_d.sent());
                    _d.label = 5;
                case 5: return [2 /*return*/, _c];
                case 6: return [4 /*yield*/, response_1
                        .json()
                        .then(function (err) { return err.message; })
                        .catch(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                        return [2 /*return*/, response_1.text()];
                    }); }); })];
                case 7:
                    error = _d.sent();
                    throw new Error(typeof error === 'string' ? error : String(error));
                case 8:
                    clearTimeout(timer);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    });
};
export default sendJsonRequest;
